module.exports = __webpack_public_path__ + "static/media/records.428933b5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/records.svg
// module id = 230
// module chunks = 0